import React, { useEffect, useState } from "react";
import Card from "@/components/common/Card";
import themeJson from "./purple-passion.json";
import { Button } from "../../../../../components/ui/button";
import { DownloadIcon } from "lucide-react";
import domtoimage from "dom-to-image";
import EChartsReact from "echarts-for-react";
// import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { useSelector } from "react-redux";

const LineChartData = (props) => {
    const { chartData, isLoading, actualPrepareAssetValueData,applyDateType, setApplyDateType, ycrAssetData, assetIds,setSelectDateType,selectDateType } =
        props;
    const { assetValueData } = useSelector((state) => state);
    const [option, setOption] = useState({});
    const [prePareData, setPrepareData] = useState(null);
    const [xAxis, setXAxis] = useState([]);
    // const [selectDateType, setSelectDateType] = useState(null);                  
    const [chartLoad, setChartLoad] = useState(false);
    // const [applyDateType, setApplyDateType] = useState(false);

    const sortRecordsByDate = (records) => {
        return records?.sort((a, b) => {
            return new Date(a.date) - new Date(b.date);
        });
    };

    // Function to group records by month
    const recordsByMonthGroup = (records, selectValue) => {
        const groupedRecords = records && records.reduce((acc, item) => {
            let time = selectValue?.value === 'year' ? "year" : "month"
            let timePrefix = selectValue?.value === 'year' ? "Yr" : "Mo"

            const year = item?.asset?.[time] ? `${item.asset[time]} ${timePrefix}` : "Other";
            if (!acc[year]) {
                acc[year] = [];
            }
            acc[year].push({
                value: item.value,
                date: new Date(item.date).toLocaleDateString("en-GB"),
                tenor: `${item?.asset?.country.alpha2Code}-${item?.asset?.maturity}-${item?.asset?.interestRateDataType?.type}`,
                country: item?.asset?.country?.alpha2Code,
            });
            delete acc?.Other;
            return acc;
        }, {});

        return { groupedRecordsByMonth: groupedRecords };
    };

    // Date Group
    const recordsByDateGroup = (records) => {
        const groupedRecords = records && records.reduce((acc, item) => {
            const dateString = new Date(item.date).toLocaleDateString("en-GB"); // Format the date
            if (!acc[dateString]) {
                acc[dateString] = [];
            }

            acc[dateString].push({
                value: item.value,
                date: dateString, // Use the formatted date string
                tenor: `${item?.asset?.country.alpha2Code}-${item?.asset?.maturity}-${item?.asset?.interestRateDataType?.type}`,
                country: item?.asset?.country?.alpha2Code,
                month: item?.asset?.month || null,
                year: item?.asset?.year || null,
            });

            return acc;
        }, {});

        return { groupedRecordsByDate: groupedRecords };
    };


    // Function to transform grouped records into ECharts series format
    const transformChartData = (chartData) => {
        let transformedData = [];
        for (let key in chartData) {
            if (chartData.hasOwnProperty(key)) {
                if (key !== 'Other') {
                    transformedData.push({
                        name: key,
                        label: key,
                        type: "line",
                        data: chartData[key],
                    });
                }
            }
        }
        return transformedData;
    };

    // Function to download chart as JPEG image
    const downloadChartAsJPEG = () => {
        prePareData.length && domtoimage.toJpeg(document.getElementById('curveTimeSeriesChart'), { quality: 0.95, backgroundColor: 'white', style: { backgroundColor: 'white', backgroundImage: 'none', margin: '0px' } })
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'my-image-name.jpeg';
                link.href = dataUrl;
                link.click();
            });
    }


    function sortDynamicMonths(arr) {
        return arr.sort((a, b) => {
            // Extract the numeric part (assuming "Mo" is always at the end)
            const numA = parseFloat(a.split(" ")[0]); // Split by space and take first part
            const numB = parseFloat(b.split(" ")[0]);

            // Sort numerically
            return numA - numB;
        });
    }

    function setAssetValuesByMonths(groupedRecordsByDate, xAxisMonths,selectValue) {
        const time = selectValue?.value === "year" ? "year" : "month"
        for (let [key, value] of Object.entries(groupedRecordsByDate)) {
            let finalValues = []

            for (let x in xAxisMonths) {
                let month = parseFloat(xAxisMonths[x].split(" ")[0]);
                const record = value.find(x => x[time] === month)

                if (record) {
                    finalValues.push(record)
                } else {
                    finalValues.push(null)
                }

            }

            groupedRecordsByDate[key] = finalValues
        }

        return groupedRecordsByDate
    }

    useEffect(() => {
        let actualFilterValueDataSort = null;

        // asset and asset values
        const actualFilterValueData = actualPrepareAssetValueData?.length > 0 && actualPrepareAssetValueData?.filter((valueData) => {
            return assetIds?.includes(valueData?.asset?._id)
        });
       
        actualFilterValueDataSort = actualFilterValueData?.length > 0 && sortRecordsByDate(actualFilterValueData);
        const { groupedRecordsByMonth } = recordsByMonthGroup(actualFilterValueDataSort, selectDateType);

        const xAxisMonths = sortDynamicMonths(Object.keys(groupedRecordsByMonth))
        const { groupedRecordsByDate } = recordsByDateGroup(actualFilterValueDataSort);
        
        let chartData = setAssetValuesByMonths(groupedRecordsByDate, xAxisMonths,selectDateType)

        const formattedChartData = transformChartData(chartData);

        setXAxis(xAxisMonths);
        setPrepareData(formattedChartData);
    }, [actualPrepareAssetValueData, selectDateType?.value]);

    useEffect(() => {
        if (
            chartData?.length &&
            assetValueData?.records?.length &&
            assetValueData?.assets?.length
        ) {
            // Set ECharts options
            const option = {
                tooltip: {
                    trigger: "item",
                    formatter: function (params) {
                        // assetValueData
                        const slug = params.name; // Main date from the x-axis
                        const value = params?.data?.value ?? "-"; // Main value
                        const additionalDate = params?.data?.date; // Replace this with your actual additional date logic

                        return `<div style=" display: flex;justify-content: space-between;align-items: center;"><span>${slug}</span> <span>${additionalDate}</span></div> <div>${params.marker} ${params?.data?.tenor} : ${value}</div> <br/>`;
                    },
                },
                legend: {
                    type: "scroll",
                    right: 0,
                    top: 0,
                    left: 0,
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    bottom: "10%",
                    containLabel: true,
                },

                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    data: xAxis,
                    axisLabel: {
                        interval: 0,
                        rotate: 60,
                        margin:10
                    },
                },
                yAxis: {
                    type: "value",
                    position: "center",
                },
                series: prePareData,
                theme: themeJson.theme,
            };

            setOption(option);
            setChartLoad(false); // Mark chart as loaded
        }
    }, [prePareData]);

    // Function to sort records by date

    const onChangeDateWiseChart = (event) => {
        setSelectDateType(event)
    }

    const DateWiseChartOptions = [
        { label: 'Month', value: 'month' },
        { label: 'Year', value: 'year' }
    ];

    const handleApplyChartDateType = () => {
        setApplyDateType(!applyDateType)
    }


    return (
        <>
            {chartData?.length > 0 && (
                <Card className="bg-white p-3 md:p-5">
                    <div className="flex justify-end">
                        {/* <div className="flex justify-center items-center gap-2 px-2">
                            <Select

                                onValueChange={(e) => onChangeDateWiseChart(JSON.parse(e))}
                            >
                                <SelectTrigger className="w-full h-[34px] min-w-[130px] text-[12px] rounded-5px] ">
                                    <SelectValue
                                        className='text-textV1 '
                                        placeholder={selectDateType !== null ? selectDateType?.label : "Select Date Type"}
                                    >
                                        {selectDateType !== null ? selectDateType?.label : "Select Date Type"}
                                    </SelectValue>
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectGroup>
                                        {
                                            DateWiseChartOptions && DateWiseChartOptions.length > 0 ? DateWiseChartOptions.map((item, index) => {
                                                return <SelectItem key={index} className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2" value={JSON.stringify(item)}>{item?.label}</SelectItem>
                                            }) : <SelectItem disabled className="text-xs flex items-center gap-2 cursor-pointer text-theme font-500 hover:bg-[#d7ebff] rounded-[4px] py-2 text-center" value={'No option'}>{'No option'}</SelectItem>
                                        }
                                    </SelectGroup>
                                </SelectContent>
                            </Select>
                            <Button className="px-5 py-[7px]" onClick={handleApplyChartDateType}>Apply</Button>
                        </div> */}
                        <Button
                            variant="outline"
                            size="sm"
                            className="w-8 h-8 p-0 hover:bg-[#F5F5F5]"
                            onClick={downloadChartAsJPEG}
                        >
                            <DownloadIcon className="w-4 h-4" />
                        </Button>
                    </div>
                    <div className="table-wrapper" id="curveTimeSeriesChart">
                        <EChartsReact
                            key="timeSeriesChart"
                            className="lineChart_curves"
                            notMerge={true}
                            lazyUpdate={chartLoad || isLoading}
                            showLoading={chartLoad || isLoading}
                            style={{ width: "100%", height: "500px" }}
                            option={option}
                            opts={{ renderer: "svg" }}
                        />
                    </div>
                </Card>
            )}
        </>
    );
};

export default LineChartData;

// old chart
// import React, { useEffect, useState } from 'react';
// import Card from '@/components/common/Card';
// import themeJson from './purple-passion.json';
// import Loading from '../../../../../components/common/Loading';
// import { Button } from '../../../../../components/ui/button';
// import { DownloadIcon } from 'lucide-react';
// import domtoimage from 'dom-to-image';
// import ReactEcharts from "echarts-for-react";

// const LineChartData = (props) => {
//     const { chartData, isLoading } = props;
//     const [option, setOption] = useState({});

//     useEffect(() => {
//         if (chartData?.length) {
//             const bondTerms = Object.keys(chartData[0]).filter(key => key !== 'date' && key !== 'borderWidth');
//             const preparedData = chartData.map(dataPoint => {
//                 // Extract date as the name and data values from other keys
//                 return {
//                     name: dataPoint.date,
//                     type: 'line',
//                     // stack: 'Total',
//                     data: Object.values(dataPoint).slice(1), // Extract data values (excluding "date")

//                 };
//             });

//             const option = {
//                 tooltip: {
//                     trigger: 'axis'
//                 },
//                 legend: {
//                     // data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
//                     type: 'scroll',
//                     right: 0,
//                     top: 0,
//                     left: 0,
//                 },
//                 grid: {
//                     left: '3%',
//                     right: '4%',
//                     bottom: '3%',
//                     containLabel: true
//                 },

//                 xAxis: {
//                     type: 'category',
//                     boundaryGap: false,
//                     data: bondTerms
//                 },
//                 yAxis: {
//                     type: 'value',
//                     position: 'center'
//                 },
//                 series: preparedData,
//                 theme: themeJson.theme
//             }

//             setOption(option)
//         }
//     }, [chartData]);

//     const downloadChartAsJPEG = () => {
//         chartData.length && domtoimage.toJpeg(document.getElementById('canvaHtml1'), { quality: 0.95, backgroundColor: 'white', style: { backgroundColor: 'white', backgroundImage: 'none', margin: '0px' } })
//             .then(function (dataUrl) {
//                 var link = document.createElement('a');
//                 link.download = 'my-image-name.jpeg';
//                 link.href = dataUrl;
//                 link.click();
//             });
//     }

//     return (
//         <>
//             {chartData?.length ? <Card className="bg-white p-3 md:p-5 ">
//                 <div className='flex justify-end'>
//                     <Button variant="outline" size="sm" className="w-8 h-8 p-0 hover:bg-[#F5F5F5]" onClick={() => downloadChartAsJPEG('echarts-chart2')}>
//                         <span><DownloadIcon className='w-4 h-4' /></span>
//                     </Button>
//                 </div>
//                 <div className="table-wrapper" id='canvaHtml1'>
//                     {isLoading ? <Loading /> : <ReactEcharts
//                         key="timeSeriesChart" // Add key prop here
//                         className={""}
//                         style={{ width: '100%', height: '500px' }}
//                         option={option}
//                     />}
//                 </div>
//             </Card> : ''}
//         </>
//     );
// }

// export default LineChartData;
